import { createClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_PUBLIC_SUPABASE_URL;
const anonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
  throw new Error('Missing VITE_PUBLIC_SUPABASE_URL / VITE_PUBLIC_SUPABASE_ANON_KEY.');
}

export const supabase = createClient(url, anonKey, {
  auth: {
    // Off, not the library default — this app's cross-domain SSO handoff
    // (consumeSsoHandoff.ts) puts access_token/refresh_token in the URL
    // hash itself and calls setSession() explicitly. With this on, the
    // client's own auto-detection races that same hash, since our handoff
    // shape (just those two params, no expires_in/token_type/type) isn't
    // the OAuth-callback shape it expects — the two competed over the same
    // hash instead of us owning it single-mindedly.
    detectSessionInUrl: false,
  },
});
